export class ContactFormHandler {
    constructor() {
        this.modal = document.querySelector('[data-component="service-guide-modal"]');
        this.phoneEmailInput = this.modal.querySelector('#phoneoremail');
        this.newsletterCheckbox = this.modal.querySelector('#newsletter');
        this.termsCheckbox = this.modal.querySelector('#terms');
        this.errorMessage = this.modal.querySelector('.error-message');
    }

    initialize() {
        this.setupPhoneEmailInput();
    }

    setupPhoneEmailInput() {
        this.phoneEmailInput?.addEventListener('input', (e) => {
            this.phoneEmailInput.value = e.target.value;
        });
    }

    isValidEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    isValidPhone(phone) {
        // Check for minimum 8 digits
        return phone.replace(/\D/g, '').length >= 8;
    }

    validate() {
        const phoneEmailValue = this.phoneEmailInput?.value?.trim() || '';
        const terms = this.termsCheckbox?.checked || false;
        const errors = [];

        if (!phoneEmailValue) {
            errors.push(this.modal.dataset.errorContactInput);
            this.phoneEmailInput.classList.add('error');
        } else {
            const isEmail = phoneEmailValue.includes('@');
            if (isEmail && !this.isValidEmail(phoneEmailValue)) {
                errors.push(this.modal.dataset.errorContactEmail);
                this.phoneEmailInput.classList.add('error');
            } else if (!isEmail && !this.isValidPhone(phoneEmailValue)) {
                errors.push(this.modal.dataset.errorContactPhone);
                this.phoneEmailInput.classList.add('error');
            } else {
                this.phoneEmailInput.classList.remove('error');
            }
        }

        if (!terms) {
            errors.push(this.modal.dataset.errorContactTerms);
            this.termsCheckbox.classList.add('error');
        } else {
            this.termsCheckbox.classList.remove('error');
        }
        
        if (errors.length > 0) {
            this.errorMessage.textContent = errors[0];
            this.errorMessage.style.visibility = 'visible';
            this.errorMessage.setAttribute('role', 'alert');
            return false;
        }
        
        this.errorMessage.textContent = '';
        this.errorMessage.style.visibility = 'hidden';
        this.errorMessage.removeAttribute('role');

        return true;
    }
    

    reset() {
        if (this.phoneEmailInput) {
            this.phoneEmailInput.value = '';
            this.phoneEmailInput.classList.remove('error');
        }

        if (this.newsletterCheckbox) {
            this.newsletterCheckbox.checked = false;
        }

        if (this.termsCheckbox) {
            this.termsCheckbox.checked = false;
            this.termsCheckbox.classList.remove('error');
        }
    }

    getFormData() {
        return {
            phoneOrEmailInput: this.phoneEmailInput?.value || '',
            newsletter: this.newsletterCheckbox?.checked || false,
            terms: this.termsCheckbox?.checked || false
        };
    }

    setFormData(data) {
        if (this.phoneEmailInput && data.phoneOrEmailInput) {
            this.phoneEmailInput.value = data.phoneOrEmailInput;
        }

        if (this.newsletterCheckbox && data.newsletter !== undefined) {
            this.newsletterCheckbox.checked = data.newsletter;
        }

        if (this.termsCheckbox && data.terms !== undefined) {
            this.termsCheckbox.checked = data.terms;
        }
    }
}